/**
 * 布局组件
 */
import EspPage from "./layout/EspPage";
import EspPageHeader from "./layout/EspPageHeader";
import EspPageMain from "./layout/EspPageMain";
import EspPageFooter from "./layout/EspPageFooter";
import EspSearchItem from "./layout/EspSearchItem";
import EspPageCard from "./layout/EspPageCard";

// import EspPagePaper from "./layout/EspPagePaper";
// import EspPageAsideMain from './layout/EspPageAsideMain'
// import EspPageMenu from './layout/EspPageMenu'
// import EspPageCollapse from './layout/EspPageCollapse'
// import EspPageColumn from './layout/EspPageColumn'
// import EspPageVertical from './layout/EspPageVertical'
/**
 * 对话框
 */
import EspElDialog from "./dialog/EspElDialog";
/**
 * 通用组件
 */
import EspEnumEdit from "./common/enum/EspEnumEdit"; // 枚举编辑
import EspEnumView from "./common/enum/EspEnumView"; // 枚举查看
import EspTextAreaView from "./common/form/EspTextAreaView"; // 文本域查看
import EspTextAreaEdit from "./common/form/EspTextAreaEdit"; // 文本域编辑
// import EspLoading from './common/load/EspLoading' //附件管理
// import EspPicsUpload from './common/file/EspPicsUpload' //多张图片
// import EspPicsView from './common/file/EspPicsView' //多张图片
// import EspFilesUpload from './common/file/EspFilesUpload' //多个文件
// import EspFilesView from './common/file/EspFilesView' //多个文件
// import EspPicUpload from './common/file/EspPicUpload' //单个图片
// import EspPicView from './common/file/EspPicView' //单个图片
// import EspFileView from './common/file/EspFileView' //文件下载
// import EspAttUpload from './platform/EspAttUpload' //附件上传(不是文件)
// import EspEnumStrEdit from './common/enum/EspEnumStrEdit' //枚举编辑
// import EspEnumTabs from './common/enum/EspEnumTabs' //枚举TABS
// import EspBooleanView from './common/enum/EspBooleanView' //枚举查看
// import EspSelectOption from './common/form/EspSelectOption' //下拉选择列表
// import EspDynCheckbox from './common/form/EspDynCheckbox' //动态复选框
/**
 * 基础模块
 */
//公司
import EspCorp from "./base/corp/EspCorp";
// import EspCorpView from './base/corp/EspCorpView'
//部门
import EspDeptdoc from "./base/deptdoc/EspDeptdoc";
import EspDeptdocView from "./base/deptdoc/EspDeptdocView";
//人员
import EspPsndoc from "./base/psndoc/EspPsndoc";
import EspPsndocM from "./base/psndoc/EspPsndocM";
import EspPsndocView from "./base/psndoc/EspPsndocView";
// import EspPsnCodeEdit from "./base/psndoc/EspPsnCodeEdit";
//字典
// import EspDefdocSelect from './base/defdoc/EspDefdocSelect'
// import EspDefdocView from './base/defdoc/EspDefdocView'
// import EspDefdocList from './base/defdoc/EspDefdocList'
// import EspDefdocListView from './base/defdoc/EspDefdocListView'
//平台模块
// import EspReportDown from './platform/EspReportDown'


export default [
  //布局
  EspPage,
  EspPageHeader,
  EspPageMain,
  EspPageFooter,
  EspSearchItem,
  EspPageCard,

  // EspPagePaper,
  // EspPageAsideMain,
  // EspPageMenu,
  // EspPageCollapse,
  // EspPageColumn,
  // EspPageVertical,
  // 对话框
  EspElDialog,

  // 通用功能组件
  // EspLoading,

  // EspFileView,
  // EspAttUpload,
  EspEnumEdit,
  EspEnumView,
  EspTextAreaView,
  EspTextAreaEdit,
  // EspEnumTabs,
  // EspBooleanView,
  // EspPicsUpload,
  // EspPicsView,
  // EspFilesUpload,
  // EspFilesView,
  // EspPicUpload,
  // EspPicView,
  // EspSelectOption,
  // EspDynCheckbox,
  // EspEnumStrEdit,

  //基础模块
  EspCorp,
  // EspCorpView,
  EspDeptdoc,
  EspDeptdocView,
  EspPsndoc,
  EspPsndocM,
  EspPsndocView,
  // EspDefdocSelect,
  // EspPsnCodeEdit,

  // EspDefdocSelect,
  // EspDefdocView,
  // EspDefdocList,
  // EspDefdocListView,

  // EspReportDown


]



// WEBPACK FOOTER //
// ./src/components/common.js